import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `ProgressBarAnnotationsDirective` directive represent a annotation of the react progressbar.
 * ```tsx
 * <progressbarComponent>
 * <ProgressBarAnnotationsDirective>
 * <ProgressBarAnnotationDirective></ProgressBarAnnotationDirective>
 * </ProgressBarAnnotationsDirective>
 * </progressbarComponent>
 * ```
 */
export class ProgressBarAnnotationDirective extends ComplexBase {
}
ProgressBarAnnotationDirective.moduleName = 'progressBarAnnotation';
export class ProgressBarAnnotationsDirective extends ComplexBase {
}
ProgressBarAnnotationsDirective.propertyName = 'annotations';
ProgressBarAnnotationsDirective.moduleName = 'progressBarAnnotations';
